/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Copied_To_ClipboardInputs */

const en_toast_copied_to_clipboard = /** @type {(inputs: Toast_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied to clipboard`)
};

const nl_toast_copied_to_clipboard = /** @type {(inputs: Toast_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekopieerd naar klembord`)
};

/**
* | output |
* | --- |
* | "Copied to clipboard" |
*
* @param {Toast_Copied_To_ClipboardInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_copied_to_clipboard = /** @type {((inputs?: Toast_Copied_To_ClipboardInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Copied_To_ClipboardInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_copied_to_clipboard(inputs)
	return en_toast_copied_to_clipboard(inputs)
});